import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const Safari = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Safari"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddSafari = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Safari"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditSafari = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Safari"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const ViewSafari = () => {
  return (
    <DoSeeDataProvider>
      <Auth
        children={
          <Screen
            component={<Detail />}
            title="Safari Details"
          />
        }
      />
    </DoSeeDataProvider>
  );
};
